var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlobRedHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffe7e0;}.cls-2{fill:#ffb8a4;}.cls-3{fill:#ff6d4f;}.cls-4{fill:#ff876b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,113.3c47.5,44.7,95,89.4,157.7,106.1,62.6,16.7,140.4,5.4,186.5,36.4,46.1,31.1,60.5,104.5,78.9,168.9,18.5,64.5,41.1,119.9,63.6,175.3H0V113.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m0,234.9c35.6,33.6,71.3,67.1,118.2,79.6,47,12.5,105.4,4.1,139.9,27.4,34.6,23.3,45.4,78.3,59.3,126.6,13.8,48.4,30.7,89.9,47.7,131.5H0V234.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m0,356.6c23.8,22.4,47.5,44.7,78.8,53.1,31.4,8.3,70.2,2.7,93.3,18.2,23,15.5,30.2,52.3,39.5,84.5,9.2,32.2,20.5,59.9,31.8,87.6H0v-243.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,478.3c11.9,11.2,23.8,22.4,39.4,26.5,15.7,4.2,35.1,1.4,46.6,9.2,11.6,7.7,15.2,26.1,19.8,42.2,4.6,16.1,10.2,29.9,15.9,43.8H0v-121.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobRedHalf);
export default __webpack_public_path__ + "static/media/blob_red_half.f4320d20de56310435f4fa6cdd45c4dd.svg";
export { ForwardRef as ReactComponent };